/* Action Types */
export const LOAD_CATALOG_SEARCH_FAIL = 'LOAD_CATALOG_SEARCH_FAIL';
export const LOAD_CATALOG_SEARCH_REQUEST = 'LOAD_CATALOG_SEARCH_REQUEST';
export const LOAD_CATALOG_SEARCH_SUCCESS = 'LOAD_CATALOG_SEARCH_SUCCESS';
export const UPDATE_FACETS_SELECTED = 'UPDATE_FACETS_SELECTED';
export const LOAD_CATALOGS_TODAY_COUNT_REQUEST = 'LOAD_CATALOGS_TODAY_COUNT_REQUEST';
export const LOAD_CATALOGS_TODAY_COUNT_SUCCESS = 'LOAD_CATALOGS_TODAY_COUNT_SUCCESS';
export const LOAD_CATALOGS_TODAY_COUNT_FAIL = 'LOAD_CATALOGS_TODAY_COUNT_FAIL';
